export class TokenModel {
  access_token: string
  expires_in: string
  token_type: string
  scope: string
  refresh_token: string
  expiresAt: any

  constructor(token) {
    if (token!!) {
      this.access_token = token.access_token
      this.expires_in = token.expires_in
      this.token_type = token.token_type
      this.scope = token.scope
      this.refresh_token = token.refresh_token
      this.expiresAt = Date.now() + token.expires_in * 1000
    }
  }

  isExpired() {
    return this.expiresAt <= Date.now()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/models/token.model.ts